import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  snackbar: {
    showing: false,
    type: 'success',
    text: '',
    timeout: 5000
  }
}

const mutations = {
  SET_SNACKBAR(state, snackbar) {
    state.snackbar = snackbar
  }
}

const actions = {
  async setSnackbar({ commit }, snackbar) {
    // snackbar.showing = true
    snackbar.timeout = snackbar.timeout === 0 ? -1 : snackbar.timeout || 5000
    commit('SET_SNACKBAR', snackbar)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
